<template>
    <div class="jd-page--certificate">
        <div v-if="cert" class="cert-box">
            <div><img :src="cert.url" alt="证书" /></div>
            <p v-if="!showBtns" class="k-nodata">长按图片发送给朋友！</p>
            <br/>
            <div class="ta-center"><k-button  @click="showImgView"><k-icon name="search"></k-icon> 查看大图</k-button></div>
        </div>
        <div v-if="noCert" class="k-nodata">暂无证书数据</div>
        <div v-if="loading" class="k-nodata">正在加载</div>

        <div class="jd-fixed-btns" v-if="cert && showBtns">
            <k-row type="flex" gutter="10" justify="center">
                <k-col span="12"><k-button type="primary" block @click="save">保存本地</k-button></k-col>
                <k-col span="12"><k-button type="danger" block @click="share">分享给朋友</k-button></k-col>
            </k-row>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"
    import {WZ,inApp, inWeiXin} from "../../utils/wz.v2";
    import { ImagePreview } from 'kvue';
    export default {
        name: "order-detail",
        data(){
            return {
                orderId : +this.$route.query.orderId || 0,
                shareImg : '',
                cert : null,
                loading : false,
                noCert : false
            }
        },
        computed : {
            ...mapGetters("jianding", ["getOrderDetail","CONST"]),
            ...mapGetters("timer", ["leftSecs"]),
            showBtns(){
                if(inWeiXin()){
                    return false
                }
                return true
            }
        },
        components : {

        },
        methods : {
            ...mapActions("jianding", ["loadOrderDetail", "loadCert"]),
            showImgView(index){
                const instance = ImagePreview({
                    images: [this.shareImg],
                    startPosition: typeof index === "number" ? index : 0,
                    onClose: () => {

                    }
                });
            },
            async load(){
                this.loading = true
                await this.loadCert({orderId : this.orderId}).then( R => {
                    this.cert = R.cert;
                    this.shareImg = R.cert.url || '';
                }).catch(err => {
                    if(err.error_code === 10001){
                        this.noCert = true
                    }
                });
                this.loading = false;
            },
            share(){
                //分享预告海报
                if (inApp()) {
                    WZ.appCall('do.shareTo', {
                        type        : 1, // 图片分享
                        image       : this.shareImg
                    });
                } else if (inWeiXin()){
                    this.$dialog.alert({
                        title       : "温馨提示",
                        message     : "长按图片分享！"
                    })
                } else {
                    this.$dialog.alert({
                        title       : "温馨提示",
                        message     : "请使用浏览器自带分享功能进行分享！或者长按图片保存到本地发送给朋友！"
                    })
                }
            },
            save(){
                this.$dialog.alert({
                    title       : "温馨提示",
                    message     : "移动端长按图片保存，<br/>电脑端图片右键另存为！"
                })
            },
            make(){
                if(window.kShare){
                    kShare.make({
                        title: to.meta.title,
                        url: location.href
                    })
                }
            }
        },
        created() {
            this.load()
        }

    }
</script>

<style scoped>

</style>